import Body from '../../components/Body';
import Posts from '../../components/Stories';
import Gallery from '../../components/Gallery';
import GeneratePreview from '../../components/GeneratePreview';
import React from 'react';

export default function LoginPage() {
  return (
    <Body>
      <GeneratePreview />
      <Gallery />
    </Body>
  );
}